import { supabase } from '@/lib/supabase'

export type RoleResultsPolicy = {
  role: string
  results_enabled: boolean
}

export type PlanResultsPolicy = {
  plan_id: string
  results_enabled: boolean
}

export async function fetchRoleResultsPolicies(): Promise<RoleResultsPolicy[]> {
  const { data, error } = await supabase
    .from('role_results_policies')
    .select('role,results_enabled')
    .order('role', { ascending: true })

  if (error) throw error
  return (data || []) as RoleResultsPolicy[]
}

export async function upsertRoleResultsPolicy(role: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('role_results_policies')
    .upsert({ role, results_enabled: enabled }, { onConflict: 'role' })

  if (error) throw error
}

export async function fetchPlanResultsPolicies(): Promise<PlanResultsPolicy[]> {
  const { data, error } = await supabase
    .from('plan_results_policies')
    .select('plan_id,results_enabled')
    .order('plan_id', { ascending: true })

  if (error) throw error
  return (data || []) as PlanResultsPolicy[]
}

export async function upsertPlanResultsPolicy(planId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('plan_results_policies')
    .upsert({ plan_id: planId, results_enabled: enabled }, { onConflict: 'plan_id' })

  if (error) throw error
}

